<div class="dates-block">
  <p-dropdown class="dates-dropdown" (onChange)="updateDate($event)" [options]="dates"
              [(ngModel)]="selectedDate" optionLabel="label" placeholder="Period">
  </p-dropdown>
</div>


<ng-container *ngIf="selectedDate.label !== 'This Month' && selectedDate.label !== 'Last Month'">
  <div class="calendar-block dates-block">
    <div class="date-label">
      From:
    </div>
    <p-calendar [(ngModel)]="selectedStartDate" view="date" [tabindex]="-1" type="date" dateFormat="M d, yy"
                name="startDate" placeholder="" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                styleClass="report-calendar" (ngModelChange)="dateChange()" (onShow)="blurActiveElement()">
    </p-calendar>
  </div>

  <div class="calendar-block dates-block date-to-block">
    <div class="date-label">
      To:
    </div>
    <p-calendar [(ngModel)]="selectedFinishDate" view="date" [tabindex]="-1" type="date" dateFormat="M d, yy"
                name="finishDate" placeholder="" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                styleClass="report-calendar" (ngModelChange)="dateChange()" (onShow)="blurActiveElement()">
    </p-calendar>
  </div>
</ng-container>

<ng-container *ngIf="selectedDate.label === 'This Month' || selectedDate.label === 'Last Month'">
  <div class="calendar-block dates-block">
    <div class="date-label arrow-label" matRipple [matRippleCentered]="true" (click)="minusMonth()">
      <i class="pi pi-angle-left"></i>
    </div>

    <p-calendar [(ngModel)]="selectedStartDate" view="month" [tabindex]="-1" type="date" dateFormat="M, yy"
                name="startDate" placeholder="" [showIcon]="false" [ngModelOptions]="{standalone: true}"
                styleClass="report-calendar" (ngModelChange)="monthChange()"
                panelStyleClass="month-changer-panel" (onShow)="blurActiveElement()">
    </p-calendar>

    <div class="date-label arrow-label" matRipple [matRippleCentered]="true" (click)="plusMonth()">
      <i class="pi pi-angle-right"></i>
    </div>
  </div>
</ng-container>


<p-multiSelect #multiSelect [defaultLabel]="'Job Status'" [selectedItemsLabel]="'{0} job statuses selected'"
               [options]="columns" [optionLabel]="'name'" [(ngModel)]="selectedColumns" [showToggleAll]="true"
               (onChange)="updateFilter()" [filter]="false" [maxSelectedLabels]="1">
  <p-header (click)="showAll(multiSelect)">
    Show All
  </p-header>
</p-multiSelect>

<p-multiSelect #multiSelect2 [defaultLabel]="'Project Managers'" [selectedItemsLabel]="'{0} managers selected'"
               [options]="users"
               styleClass="payment-multiselect" [optionLabel]="'username'" [(ngModel)]="selectedUsers"
               [showToggleAll]="true"
               (onChange)="updateFilter()" [filter]="false" [maxSelectedLabels]="1">
  <p-header (click)="showAll(multiSelect2)">
    Show All
  </p-header>
</p-multiSelect>

<p-multiSelect #multiSelect3 [defaultLabel]="'Payment Statuses'" [selectedItemsLabel]="'{0} payment statuses selected'"
               [options]="statuses" styleClass="payment-multiselect"
               [optionLabel]="'title'" [(ngModel)]="selectedStatuses" [showToggleAll]="true" (onChange)="updateFilter()"
               [filter]="false" [maxSelectedLabels]="1">
  <p-header (click)="showAll(multiSelect3)">
    Show All
  </p-header>
</p-multiSelect>

<p-multiSelect #multiSelect3 [defaultLabel]="'Installation Payment Statuses'" [selectedItemsLabel]="'{0} installation statuses selected'"
               [options]="installStatuses" styleClass="payment-multiselect"
               [optionLabel]="'title'" [(ngModel)]="selectedInstallStatuses" [showToggleAll]="true" (onChange)="updateFilter()"
               [filter]="false" [maxSelectedLabels]="1">
  <p-header (click)="showAll(multiSelect3)">
    Show All
  </p-header>
</p-multiSelect>
